import V9MainImg from '../Img/Prime_Force_Main_Img.png'
import V9MicImg from '../Img/V9_Mic_Img.png'
import V9CompanyBuildingImg from '../Img/V9_Company_Building_Img.png'
import { computeHeadingLevel } from '@testing-library/dom';
import AboutHomeSection from './AboutHomeSection';
import WhyChooseUsSection from './WhyChooseUs';
import OurStrengthSection from './OurStrengthSection';
import OurApproachSection from './OurApproachSection';
import CounterSection from './CounterSection';
import Services from './Services';
import HomeIndustries from './HomeIndustry';
import Testimonial from './Testimonial';
import CallToAction from './CallToAction';

const Home = () => {
    return (
        <>
            <div className="home-v9">
                <div className="home-main-section-v9">
                    <div className="home-main-container-v9">
                        <h1 className="home-main-heading-v9">
                            Your Trusted Partner in Manpower Solutions
                        </h1>
                        <h3 className="animate__animated">Delivering Skilled Workforce to Meet Your Business Needs</h3>
                        {/* <p className="animate__animated">At V9 Primeforce, we don’t just fill positions — we fuel potential. We connect companies with high-performing talent and empower individuals with opportunities that elevate careers and transform lives.</p> */}

                        <img src={V9MainImg} alt="" className="animate__animated animate__bounceInUp" />
                    </div>
                    {/* <img src={V9MicImg} alt="" className="home-main-mic-img-v9" />
                    <img src={V9CompanyBuildingImg} alt="" className="home-main-company-bldg-img-v9" /> */}
                </div>
            </div>
            <AboutHomeSection />
            <Services />
            <WhyChooseUsSection />
            <OurStrengthSection />
            <HomeIndustries />
            <Testimonial/>
            <CallToAction />
            {/* <OurApproachSection />
            <CounterSection /> */}
        </>
    );
};

export default Home;